import { UserDataHelper } from "../lib/user-data-helper";
import Api from "../lib/api";
import {AnalyticsService} from "./analytics-service";

export default class UserDataService {
	constructor() {
		this.lmsUserData = null;
		this.lmsUserDataLoaded = false;

		this.lmsUserDataLoadedEvent = 'LMS_USER_DATA_LOADED';

		this.init();
	}

	init() {
		UserDataHelper.setUUID();
	}

	fetchLMSUserData() {
		return Api.get(`${Api.lmsApiUrl}/users/site/mydata`, {}, {
			withCredentials: true
		}).then((data) => {
			if (data && data.success) {
				this.lmsUserData = data.response;

				this.saveLMSUserData({ ...this.lmsUserData });

				document.body.classList.add('-logged-in');
			}
		}).catch((error) => {
		}).finally(() => {
			document.body.classList.add('-user-data-loaded');
			this.lmsUserDataLoaded = true;
			window.dispatchEvent(new Event(this.lmsUserDataLoadedEvent));
		});
	}

	saveLMSUserData(data) {
		if (!data) return;

		const userData = costorage.get('h_lmsUser');

		if (!userData) {
			this.identifyLMSUser(data);
			return;
		}

		const parsedUserData = JSON.parse(userData);

		for (const key of Object.keys(parsedUserData)) {
			if (data[key] !== parsedUserData[key]) {
				this.identifyLMSUser(data);
				break;
			}
		}
	}

	identifyLMSUser(data) {
		if (!data) return;

		costorage.set('h_lmsUser', JSON.stringify(data), { expires: 30 * 24 * 60 * 60, path: '/', domain: '.ithillel.ua' });

		const analyticsPersonProperties = { ...data };

		if (analyticsPersonProperties['_id']) {
			Object.assign(analyticsPersonProperties, {
				lms_id: analyticsPersonProperties['_id']
			});
			delete analyticsPersonProperties['_id'];
		}

		AnalyticsService.setPersonProperties(analyticsPersonProperties);
	}

	getLMSUserData() {
		if (this.lmsUserData) {
			return this.lmsUserData;
		}

		const userData = costorage.get('h_lmsUser');

		if (!userData) {
			return undefined;
		}

		return JSON.parse(userData);
	}

	getLMSUserId() {
		const userData = this.getLMSUserData();

		if (!userData || !userData['_id']) {
			return undefined;
		}

		return userData['_id'];
	}
}